// Wrapper
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ElementWrapper = (props) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const Element = props.routeElement;

  return (
    <Element
      params={params}
      location={location}
      navigate={navigate}
      key={location.pathname}
      {...props}
    />
  );
};

export default ElementWrapper;
